import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { UserErrorHandlerService } from './user-error-handler.service';

import { EasyDebugDecorator } from '../../app/decorators/easy-debug.decorator';
import { ShortTermExamPlanning, SlotModel } from '@app/app.models';

@Injectable({ providedIn: 'root' })
@EasyDebugDecorator
export class ExamenConduiteService {
  constructor(
    private http: HttpClient,
    private userErrorHandlerService: UserErrorHandlerService
  ) {}

  async fetchDrivingExamenById(drivingExamId: string): Promise<any> {
    let url: string;

    // url = `${environment.token_auth_config.apiBase}/v${environment.apiVersion}/account/${accountId}/theory_tests`;
    url = `${environment.token_auth_config.apiBase}/v${environment.apiVersion}/driving_exam/${drivingExamId}`;

    return this.http
      .get(url)
      .pipe(
        switchMap((data) => {
          return of(data);
        }),
        catchError(async (err) => {
          this.userErrorHandlerService.addError({
            criticity: 40,
            service: 'fetchDrivingExamenById',
            platform: 'both',
            data: err,
            errorCode: 'ecsfdebi',
          });
          return {
            errorCode: 'E301',
            errorMessage: 'DrivingExam Service failed',
            errorOriginal: err,
          };
        })
      )
      .toPromise();
  }

  async getShortTermExamPlanning(): Promise<any> {
    let url = `${environment.token_auth_config.apiBase}/v3/express_exam_planning`;

    return this.http
      .get(url)
      .pipe(
        switchMap((data: ShortTermExamPlanning) => {
          return of(data);
        }),
        catchError(async (err) => {
          this.userErrorHandlerService.addError({
            criticity: 40,
            service: 'getShortTermExamPlanning',
            platform: 'both',
            data: err,
            errorCode: 'ecsgctep',
          });
          return {
            errorCode: 'E301',
            errorMessage: 'DrivingExam Service failed',
            errorOriginal: err,
          };
        })
      )
      .toPromise();
  }

  async updateShortTermExamPlanning(planning: Array<SlotModel>): Promise<any> {
    let url = `${environment.token_auth_config.apiBase}/v3/express_exam_planning`;

    const data = planning.map((slot: SlotModel) => {
      const { formatted_date: _, ...finalSlot } = slot;
      return finalSlot;
    });

    return this.http
      .put(url, { planning: data })
      .pipe(
        switchMap((data: Array<SlotModel>) => {
          return of(data);
        }),
        catchError(async (err) => {
          this.userErrorHandlerService.addError({
            criticity: 40,
            service: 'updateShortTermExamPlanning',
            platform: 'both',
            data: err,
            errorCode: 'ecsuctep',
          });
          return {
            errorCode: 'E301',
            errorMessage: 'DrivingExam Service failed',
            errorOriginal: err,
          };
        })
      )
      .toPromise();
  }
}
